import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class CopyRoomCollapsibleTitle extends Component {
  constructor(props) {
    super(props);
  }

  selectEvent = (e) => {
    e.stopPropagation();
    this.props.selectEvent(this.props.id);
  };

  render() {
    return (
      <span className="collapsible-header">
        <span>{this.props.testDate}</span>
        <button
          className="btn btn-outline btn-small"
          disabled={!this.props.canBeCopied}
          onClick={this.selectEvent}>
          {this.props.t('roomBuilder.selectEventButton')}
        </button>
      </span>
    );
  }
}

export default withTranslation()(CopyRoomCollapsibleTitle);

CopyRoomCollapsibleTitle.propTypes = {
  id: PropTypes.string.isRequired,
  testDate: PropTypes.string.isRequired,
  canBeCopied: PropTypes.bool.isRequired,
  selectEvent: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
